<template>
  <section ref="homePageCarousel">
    <div class="tw:flex tw:flex-row tw:w-vw tw:overflow-hidden carousel-container">
      <div class="inner carousel" ref="inner" :style="innerStyles">
        <div v-for="item in slides" :key="item.id" :id="item.id" class="tw:inline-block tw:align-top">
          <div
            ref="sliderBoxesRef"
            class="tw:md:h-[270px] tw:lg:h-[450px] tw:lg:w-[980px] tw:lg:min-w-[980px] tw:lg:mx-[calc((100vw-980px)/2)] tw:md:w-[638px] tw:md:min-w-[638px] tw:md:mx-[calc((100vw-638px)/2)] tw:sm:w-[480px] tw:sm:min-w-[480px] tw:sm:mx-[calc((100vw-480px)/2)] tw:w-[300px] tw:min-w-[300px] tw:mx-[calc((100vw-300px)/2)] tw:m-auto"
          >
            <div
              class="tw:md:min-h-[208px] tw:md:max-h-[208px] tw:lg:min-h-[300px] tw:lg:max-h-[300px] tw:h-full tw:flex tw:flex-col tw:md:flex-row tw:whitespace-normal tw:lg:items-stretch tw:mt-7 tw:mb-11 tw:lg:my-16 tw:items-end"
            >
              <div
                class="tw:flex tw:flex-col tw:items-center tw:md:items-start tw:md:h-full"
                :class="
                  item.hasBg
                    ? 'tw:w-auto tw:lg:max-w-[456px] tw:md:max-w-[340px] tw:md:mr-[20px] tw:lg:mr-[40px] tw:justify-end'
                    : 'tw:lg:max-w-[45%] tw:md:max-w-[50%] tw:lg:max-w-[423px] tw:md:justify-center tw:md:pr-[18px] tw:lg:pr-0'
                "
              >
                <div v-if="!item.hasBg" class="tw:lg:mr-[37px]">
                  <p
                    class="tw:text-2xl tw:lg:text-header-big tw:font-bold tw:mb-4 tw:text-center tw:md:text-left"
                    :class="{ 'tw:w-[115%]': language === 'el-GR' }"
                    v-html="$t(item.title)"
                  />
                  <p
                    class="tw:text-xs tw:md:text-sm tw:lg:text-lg tw:text-center tw:md:text-left tw:leading-[20px] tw:md:leading-[30px]"
                    v-html="$t(item.text)"
                  />
                </div>

                <div v-else class="tw:flex tw:flex-col tw:items-center tw:md:items-start tw:flex-1">
                  <div
                    class="tw:font-bold tw:bg-red-700 tw:text-white tw:uppercase tw:text-[8px] tw:md:text-[10px] tw:rounded-br-[12px] tw:rounded-tl-[12px] tw:w-auto tw:md:py-[1px] tw:px-2 tw:md:flex-start"
                  >
                    {{ $t(item.badge) }}
                  </div>
                  <img
                    :src="item.logo"
                    :alt="item.title"
                    class="tw:w-auto tw:h-[18px] tw:md:h-[15px] tw:lg:h-[28px] tw:md:mb-3 tw:md:mt-[10px] tw:my-[10px] tw:lg:mb-4 tw:lg:mt-[14px]"
                  />
                  <p class="tw:text-center tw:md:text-left tw:text-sm tw:md:text-base tw:lg:text-xl tw:font-bold">
                    {{ $t(item.text) }}
                  </p>
                </div>
                <MainButton
                  @click="onLoginClick(item)"
                  class="tw:hidden tw:lg:flex"
                  :class="{ 'tw:lg:mt-[30px]': !item.hasBg }"
                  >{{ $t(item.buttonLabel) }}</MainButton
                >
                <MainButton @click="onLoginClick(item)" size="medium" class="tw:mt-4 tw:lg:hidden">{{
                  $t(item.buttonLabel)
                }}</MainButton>
              </div>
              <div
                class="tw:relative tw:mt-4 tw:md:mt-0 tw:mx-auto tw:flex tw:justify-center tw:md:justify-end tw:md:items-end"
              >
                <button @click="next" class="tw:hidden tw:md:flex">
                  <img
                    :src="SliderArrow"
                    alt="arrow"
                    class="tw:absolute tw:z-999 tw:right-[-18px] tw:top-[50%] tw:translate-y-[-50%]"
                  />
                </button>

                <div
                  v-if="!item.hasBg && item.image"
                  class="tw:lg:max-w-[520px] tw:flex tw:justify-center tw:items-center tw:md:justify-end tw:md:items-end"
                >
                  <img
                    :src="item.image"
                    :alt="$t(item.title)"
                    class="tw:lg:max-w-[525px] tw:md:w-auto tw:h-[140px] tw:md:h-[186px] tw:lg:h-auto tw:mx-auto"
                  />
                </div>
                <div
                  v-else
                  class="tw:w-auto tw:flex tw:justify-end tw:rounded-xl line-shadow tw:max-h-[146px] tw:md:max-h-[190px] tw:md:max-w-[300px] tw:max-w-[250px] tw:mx-auto tw:md:max-w-[300px] tw:lg:max-h-[296px] tw:lg:max-w-[454px] tw:w-full"
                >
                  <div
                    class="tw:border tw:border-black tw:object-cover tw:rounded-lg tw:w-[250px] tw:md:min-w-[300px] tw:lg:w-[454px] tw:md:w-auto tw:h-[146px] tw:md:h-[190px] tw:lg:h-[296px]"
                    :class="`${item.id}`"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref, onMounted, onUnmounted, nextTick, computed, watch, onUpdated } from 'vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import TouchEvent from '@/utils/touchEvents'
import appAnalytics from '@/utils/tracking'
import { useSessionValues } from '@/composables/useSessionValues'

const DESKTOP_SLIDES = {
  gb: new URL('/src/assets/img/landing/slider/home_page_uk.png', import.meta.url),
  us: new URL('/src/assets/img/landing/slider/home_page_us.png', import.meta.url),
  br: new URL('/src/assets/img/landing/slider/home_page_br.png', import.meta.url),
  de: new URL('/src/assets/img/landing/slider/home_page_de.png', import.meta.url),
  es: new URL('/src/assets/img/landing/slider/home_page_es.png', import.meta.url),
  fr: new URL('/src/assets/img/landing/slider/home_page_fr.png', import.meta.url),
  it: new URL('/src/assets/img/landing/slider/home_page_it.png', import.meta.url),
  jp: new URL('/src/assets/img/landing/slider/home_page_jp.png', import.meta.url),
  gr: new URL('/src/assets/img/landing/slider/home_page_gr.png', import.meta.url),
  mx: new URL('/src/assets/img/landing/slider/home_page_mx.png', import.meta.url),
  nl: new URL('/src/assets/img/landing/slider/home_page_nl.png', import.meta.url),
  pl: new URL('/src/assets/img/landing/slider/home_page_pl.png', import.meta.url),
  pt: new URL('/src/assets/img/landing/slider/home_page_pt.png', import.meta.url),
  ru: new URL('/src/assets/img/landing/slider/home_page_ru.png', import.meta.url),
  tr: new URL('/src/assets/img/landing/slider/home_page_tr.png', import.meta.url),
}

const MOBILE_SLIDES = {
  br: new URL('/src/assets/img/landing/slider/home_page_mobile_br.png', import.meta.url),
  es: new URL('/src/assets/img/landing/slider/home_page_mobile_es.png', import.meta.url),
  fr: new URL('/src/assets/img/landing/slider/home_page_mobile_fr.png', import.meta.url),
  gr: new URL('/src/assets/img/landing/slider/home_page_mobile_gr.png', import.meta.url),
  mx: new URL('/src/assets/img/landing/slider/home_page_mobile_mx.png', import.meta.url),
  pt: new URL('/src/assets/img/landing/slider/home_page_mobile_pt.png', import.meta.url),
}

const MOBILE_GENERAL = new URL('/src/assets/img/landing/slider/home_page_mobile.png', import.meta.url)

const BusinessPlusLogo = new URL('/src/assets/img/landing/landing_studio_plus.svg', import.meta.url)
const RateConnectLogo = new URL('/src/assets/img/landing/landing_rate_connect.svg', import.meta.url)
const BusinessStudioLogo = new URL('/src/assets/img/landing/landing_business_studio.svg', import.meta.url)

const SliderArrow = new URL('/src/assets/img/landing/icons/slider_arrow.svg', import.meta.url)

const isMobile = ref(false)
const { language } = useSessionValues()
const langCode = computed(() => {
  const locale = language.value || 'en-US'
  return locale.split('-')[1].toLowerCase()
})
const slide1Img = computed(() => {
  const code = langCode.value

  if (isMobile.value) {
    return MOBILE_SLIDES[code] || MOBILE_GENERAL
  }

  return DESKTOP_SLIDES[code] || DESKTOP_SLIDES.us
})

const slides = ref([
  {
    image: slide1Img,
    title: 'tbs_mp_headline',
    text: 'tbs_mp_header_text',
    id: 'slide_1',
    badge: '',
    logo: null,
    hasBg: false,
    buttonLabel: 'tbs_mp_cta_register',
    event: appAnalytics.events.LP_SLIDE_ONE_REGISTER_NOW_CLICKED,
  },
  {
    title: 'trivago Business Studio',
    text: 'tbs_mp_studio_slideout',
    id: 'slide_2',
    badge: 'tbs_mp_free_tag',
    logo: BusinessStudioLogo,
    hasBg: true,
    buttonLabel: 'tbs_mp_cta_register',
    event: appAnalytics.events.LP_SLIDE_BUSINESS_STUDIO_REGISTER_NOW_CLICKED,
  },
  {
    title: 'trivago Business Studio+',
    text: 'tbs_mp_plus_slideout',
    id: 'slide_3',
    badge: 'best_value_tag',
    logo: BusinessPlusLogo,
    hasBg: true,
    buttonLabel: 'studio_plus_mp_cta',
    event: appAnalytics.events.LP_SLIDE_STUDIO_PLUS_START_SUBSCRIPTION_CLICKED,
  },
  {
    title: 'trivago Rate Connect',
    text: 'tbs_mp_rc_slideout',
    id: 'slide_4',
    badge: 'tbs_mp_rc_tag',
    logo: RateConnectLogo,
    hasBg: true,
    buttonLabel: 'check_out_page_rc_cta',
    event: appAnalytics.events.LP_SLIDE_RATE_CONNECT_START_CAMPAIGN_CLICKED,
  },
])

const emit = defineEmits(['onLoginClick'])
const onLoginClick = item => {
  appAnalytics.track(item.event)
  emit('onLoginClick')
}
const homePageCarousel = ref(null)
const touchEvent = ref(null)
const current = ref(0)
const timer = ref('')
const inner = ref(null)
const innerStyles = ref({})
const step = ref('')
const transitioning = ref(false)
const sliderBoxesRef = ref(null)

const setEqualHeight = () => {
  if (window.innerWidth > 767) {
    return
  }

  const boxes = sliderBoxesRef.value
  if (!boxes || boxes.length === 0) return

  boxes.forEach(box => {
    box.style.height = 'auto'
  })

  let maxHeight = 0
  boxes.forEach(box => {
    if (box.offsetHeight > maxHeight) {
      maxHeight = box.offsetHeight
    }
  })

  boxes.forEach(box => {
    box.style.height = maxHeight + 24 + 'px'
  })
}
watch(language, () => {
  nextTick(() => {
    setEqualHeight()
  })
})

const checkScreenSize = () => {
  isMobile.value = window.innerWidth < 768
}

onUpdated(() => setEqualHeight())

onMounted(async () => {
  await nextTick()
  checkScreenSize()
  setEqualHeight()
  setStep()
  autoplay()
  document.addEventListener('touchstart', event => {
    touchEvent.value = new TouchEvent(event)
  })

  document.addEventListener('touchend', handleSwipe)

  window.addEventListener('resize', checkScreenSize)
})

onUnmounted(() => {
  clearInterval(timer)
  document.removeEventListener('touchend', handleSwipe)
  window.removeEventListener('resize', checkScreenSize)
})

const afterTransition = callback => {
  const listener = () => {
    callback()
    inner.value?.removeEventListener('transitionend', listener)
  }
  inner.value?.addEventListener('transitionend', listener)
}

const resetTranslate = () => {
  innerStyles.value = {
    transition: 'none',
    transform: `translateX(0)`,
  }
}

const setStep = () => {
  const innerWidth = inner.value?.scrollWidth
  const totalCards = slides.value.length

  step.value = `${innerWidth / totalCards}`
}

const next = () => {
  if (transitioning.value) return
  transitioning.value = true
  moveLeft()
  afterTransition(() => {
    const firstElementId = window.document.querySelector('.carousel').firstElementChild.id
    const item = window.document.getElementById(firstElementId)
    item.parentNode.appendChild(item)
    if (firstElementId === 'slide_1') current.value = 1
    if (firstElementId === 'slide_2') current.value = 2
    if (firstElementId === 'slide_3') current.value = 3
    if (firstElementId === 'slide_4') current.value = 0

    resetTranslate()
    transitioning.value = false
  })
}

const moveLeft = () => {
  innerStyles.value = {
    transform: `translateX(-${step.value}px)`,
  }
}

const prev = () => {
  if (transitioning.value) return
  transitioning.value = true
  moveRight()
  afterTransition(() => {
    const lastElementId = window.document.querySelector('.carousel').lastElementChild.id
    const item = window.document.getElementById(lastElementId)
    item.parentNode.prepend(item)

    if (lastElementId === 'slide_1') current.value = 0
    if (lastElementId === 'slide_2') current.value = 1
    if (lastElementId === 'slide_3') current.value = 2
    if (lastElementId === 'slide_4') current.value = 3

    resetTranslate()
    transitioning.value = false
  })
}

const moveRight = () => {
  innerStyles.value = {
    transform: `translateX(${step.value}px)`,
  }
}

const autoplay = () => {
  timer.value = setTimeout(() => {
    next()
    setInterval(next, 7000)
  }, 7000)
}

const handleSwipe = event => {
  if (homePageCarousel.value?.contains(event.target)) {
    if (!touchEvent.value) {
      return
    }
    touchEvent.value.setEndEvent(event)

    if (touchEvent.value.isSwipeRight()) {
      prev()
    } else if (touchEvent.value.isSwipeLeft()) {
      next()
    }
    touchEvent.value = null
  }
}
</script>
<style scoped>
.carousel {
  display: block;
  margin: auto;
  white-space: nowrap;
  transition: transform 1s;
  max-height: 450px;
  @media (min-width: 768px) and (max-width: 1024px) {
    width: auto;
    max-height: 270px;
  }
  @media (max-width: 768px) {
    width: auto;
  }
}
.line-shadow {
  box-shadow: 3px 3px 0px 0px #000;
}

.slide_2 {
  background-image: url(../../assets/img/landing/slider/landing_slide_studio.jpg);
  background-size: cover;
  background-position: center;
}

.slide_3 {
  background-image: url(../../assets/img/landing/slider/landing_slide_plus.jpg);
  background-size: cover;
  background-position: center;
}
.slide_4 {
  background-image: url(../../assets/img/landing/slider/landing_slide_rc.jpg);
  background-size: cover;
  background-position: center;
}
</style>
